import axiosClient from "./axiosClient";

export const login = (email, password) =>
  axiosClient.post("/auth/login", { email, password }).then((r) => r.data);

export const registrarCliente = (data) =>
  axiosClient.post("/auth/registro", data).then((r) => r.data);

export const validarEmail = (token) =>
  axiosClient.post("/auth/validar-email", { token }).then((r) => r.data);

export const solicitarResetPassword = (email) =>
  axiosClient.post("/auth/solicitar-reset-password", { email }).then((r) => r.data);

export const resetPassword = (token, password, confirmarPassword) =>
  axiosClient.post("/auth/reset-password", { token, password, confirmarPassword }).then((r) => r.data);
